// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/Profile.css - FINAL VERSION (with stronger button alignment fix) */

.profile-page-header {
  position: relative;
  text-align: center;
  margin-bottom: 2rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}
.profile-page-header h1 {
  display: inline-block;
  margin: 0;
  color: var(--text-primary);
}

/* Admin Panel Button Styling */
.admin-header-button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  background: transparent;
  border: 1px solid var(--border-primary);
  color: var(--text-accent);
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.6rem 1.2rem;
  border-radius: var(--border-radius-lg);
  transition: all 0.3s ease;
  white-space: nowrap;
}
.admin-header-button:hover {
  background: var(--bg-accent-light);
  border-color: var(--text-accent);
  color: var(--text-accent);
  transform: translateY(-50%) scale(1.03);
  box-shadow: 0 4px 15px rgba(220, 38, 38, 0.1);
}
.admin-header-button svg {
  width: 16px;
  height: 16px;
  color: currentColor;
}

/* Profile Form Container */
.profile-form-container {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-3xl);
  padding: 1.8rem 2.2rem;
  width: 100%;
  max-width: 680px;
  margin: 2rem auto;
  box-shadow: var(--shadow-2xl);
  position: relative;
  overflow: hidden;
}
.profile-form-container h2 {
  margin-bottom: 1.5rem;
  color: var(--text-primary);
  text-align: center;
  font-weight: 600;
}
.profile-form-container .form-group {
  margin-bottom: 1rem;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 500px) {
  .form-grid { grid-template-columns: 1fr; gap: 0; }
  .form-grid .form-group { margin-bottom: 1rem; }
}

/* Form Elements */
.profile-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: 500;
}
.profile-form-container .form-group input,
.profile-form-container .form-group textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-lg);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
  box-sizing: border-box;
}
.profile-form-container .form-group textarea {
  resize: vertical;
  min-height: 80px;
}
.profile-form-container .form-group input:focus,
.profile-form-container .form-group textarea:focus {
  outline: none;
  border-color: var(--text-accent);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
  background: var(--bg-primary);
}
.profile-form-container .form-group input:disabled,
.profile-form-container .form-group textarea:disabled {
  background: var(--border-primary) !important;
  color: var(--text-secondary) !important;
  border-color: var(--border-primary) !important;
  cursor: not-allowed !important;
  opacity: 0.8 !important;
}

/* --- Profile Action Buttons Container --- */
.profile-actions {
  display: flex;
  gap: 1rem;
  /* CHANGE THIS LINE: */
  justify-content: center; /* Align buttons to the CENTER */
  /* Was: justify-content: flex-end; */
  align-items: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-primary);
  width: 100%;
}

/* Base styles FOR ALL BUTTONS INSIDE .profile-actions */
/* Increased Specificity and Explicit Display Type */
div.profile-actions > button.auth-button,
div.profile-actions > button.profile-logout-button {
  /* Override width from Auth.css and ensure it acts as a flex item */
  width: auto !important; /* Force override */
  display: inline-flex !important; /* Ensure it behaves correctly in flex */
  /* Consistent styles */
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  text-align: center;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  margin-top: 0; /* Override margin-top from .auth-button if present */
}

/* Style PRIMARY auth-button WITHIN profile-actions (Edit Profile / Save Changes) */
div.profile-actions > button.auth-button:not(.secondary) {
  background-image: var(--gradient-button);
  background-color: var(--primary-red-medium);
  color: var(--text-on-gradient);
  border: none;
  box-shadow: var(--shadow-lg);
}
div.profile-actions > button.auth-button:not(.secondary):hover:not(:disabled) {
  box-shadow: var(--shadow-button-hover);
  transform: scale(1.03);
}

/* Style SECONDARY auth-button WITHIN profile-actions (Cancel) */
div.profile-actions > button.auth-button.secondary {
  background: transparent !important;
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  box-shadow: none;
}
div.profile-actions > button.auth-button.secondary:hover:not(:disabled) {
  background: var(--bg-secondary) !important;
  border-color: var(--text-secondary);
  box-shadow: var(--shadow-lg);
  transform: scale(1.03);
}

/* Specific Style ONLY for Profile Logout Button */
div.profile-actions > button.profile-logout-button {
  background: var(--error-color); /* Red background */
  color: white; /* White text */
  border: none; /* No border */
}
div.profile-actions > button.profile-logout-button:hover:not(:disabled) {
  background: var(--primary-red-dark); /* Darker red on hover */
  box-shadow: var(--shadow-lg);
  transform: scale(1.03);
}

/* Disabled state for ALL buttons inside profile-actions */
div.profile-actions > button.auth-button:disabled,
div.profile-actions > button.profile-logout-button:disabled {
  background: var(--border-primary) !important; /* Use background property */
  background-image: none !important; /* Remove gradient */
  color: var(--text-secondary) !important;
  border-color: var(--border-primary) !important;
  cursor: not-allowed;
  opacity: 0.8;
  box-shadow: none;
  transform: none;
}


/* Profile messages */
.profile-form-container .error-message,
.profile-form-container .success-message {
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .profile-form-container { padding: 1.5rem !important; }
}
@media (max-width: 500px) {
  .profile-actions {
    flex-direction: column-reverse; /* Stack buttons */
    align-items: center; /* Center items horizontally */
  }
  /* Target ALL direct button children */
  .profile-actions > button {
    width: 100%; /* Ensure full width */
    max-width: 300px; /* Limit max width on mobile */
  }
  .profile-page-header { padding: 0 0.5rem; }
  .admin-header-button {
      position: static; transform: none; margin-top: 1rem; display: block;
      margin-left: auto; margin-right: auto; max-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Profile.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;EACzB,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,uCAAuC;EACvC,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa,0BAA0B,EAAE,MAAM,EAAE;EACjD,yBAAyB,mBAAmB,EAAE;AAChD;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,uCAAuC;EACvC,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,gCAAgC;EAChC,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;;EAEE,4CAA4C;EAC5C,uCAAuC;EACvC,8CAA8C;EAC9C,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,uBAAuB,EAAE,gCAAgC;EACzD,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;AACb;;AAEA,wDAAwD;AACxD,oDAAoD;AACpD;;EAEE,mEAAmE;EACnE,sBAAsB,EAAE,mBAAmB;EAC3C,+BAA+B,EAAE,wCAAwC;EACzE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,qDAAqD;AACtE;;AAEA,mFAAmF;AACnF;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,kCAAkC;EAClC,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,8BAA8B,EAAE,mBAAmB;EACnD,YAAY,EAAE,eAAe;EAC7B,YAAY,EAAE,cAAc;AAC9B;AACA;EACE,mCAAmC,EAAE,wBAAwB;EAC7D,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;;EAEE,4CAA4C,EAAE,4BAA4B;EAC1E,iCAAiC,EAAE,oBAAoB;EACvD,uCAAuC;EACvC,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;;AAGA,qBAAqB;AACrB;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B,0BAA0B,EAAE;AACxD;AACA;EACE;IACE,8BAA8B,EAAE,kBAAkB;IAClD,mBAAmB,EAAE,8BAA8B;EACrD;EACA,sCAAsC;EACtC;IACE,WAAW,EAAE,sBAAsB;IACnC,gBAAgB,EAAE,8BAA8B;EAClD;EACA,uBAAuB,iBAAiB,EAAE;EAC1C;MACI,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;MACnE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB;EAC3D;AACF","sourcesContent":["/* frontend/src/styles/Profile.css - FINAL VERSION (with stronger button alignment fix) */\n\n.profile-page-header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 2rem;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.profile-page-header h1 {\n  display: inline-block;\n  margin: 0;\n  color: var(--text-primary);\n}\n\n/* Admin Panel Button Styling */\n.admin-header-button {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  background: transparent;\n  border: 1px solid var(--border-primary);\n  color: var(--text-accent);\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0.6rem 1.2rem;\n  border-radius: var(--border-radius-lg);\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n.admin-header-button:hover {\n  background: var(--bg-accent-light);\n  border-color: var(--text-accent);\n  color: var(--text-accent);\n  transform: translateY(-50%) scale(1.03);\n  box-shadow: 0 4px 15px rgba(220, 38, 38, 0.1);\n}\n.admin-header-button svg {\n  width: 16px;\n  height: 16px;\n  color: currentColor;\n}\n\n/* Profile Form Container */\n.profile-form-container {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-3xl);\n  padding: 1.8rem 2.2rem;\n  width: 100%;\n  max-width: 680px;\n  margin: 2rem auto;\n  box-shadow: var(--shadow-2xl);\n  position: relative;\n  overflow: hidden;\n}\n.profile-form-container h2 {\n  margin-bottom: 1.5rem;\n  color: var(--text-primary);\n  text-align: center;\n  font-weight: 600;\n}\n.profile-form-container .form-group {\n  margin-bottom: 1rem;\n}\n\n/* Form Grid */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n@media (max-width: 500px) {\n  .form-grid { grid-template-columns: 1fr; gap: 0; }\n  .form-grid .form-group { margin-bottom: 1rem; }\n}\n\n/* Form Elements */\n.profile-form-container .form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n.profile-form-container .form-group input,\n.profile-form-container .form-group textarea {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-lg);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n.profile-form-container .form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n.profile-form-container .form-group input:focus,\n.profile-form-container .form-group textarea:focus {\n  outline: none;\n  border-color: var(--text-accent);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);\n  background: var(--bg-primary);\n}\n.profile-form-container .form-group input:disabled,\n.profile-form-container .form-group textarea:disabled {\n  background: var(--border-primary) !important;\n  color: var(--text-secondary) !important;\n  border-color: var(--border-primary) !important;\n  cursor: not-allowed !important;\n  opacity: 0.8 !important;\n}\n\n/* --- Profile Action Buttons Container --- */\n.profile-actions {\n  display: flex;\n  gap: 1rem;\n  /* CHANGE THIS LINE: */\n  justify-content: center; /* Align buttons to the CENTER */\n  /* Was: justify-content: flex-end; */\n  align-items: center;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-primary);\n  width: 100%;\n}\n\n/* Base styles FOR ALL BUTTONS INSIDE .profile-actions */\n/* Increased Specificity and Explicit Display Type */\ndiv.profile-actions > button.auth-button,\ndiv.profile-actions > button.profile-logout-button {\n  /* Override width from Auth.css and ensure it acts as a flex item */\n  width: auto !important; /* Force override */\n  display: inline-flex !important; /* Ensure it behaves correctly in flex */\n  /* Consistent styles */\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: var(--border-radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n  text-align: center;\n  text-decoration: none;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0; /* Override margin-top from .auth-button if present */\n}\n\n/* Style PRIMARY auth-button WITHIN profile-actions (Edit Profile / Save Changes) */\ndiv.profile-actions > button.auth-button:not(.secondary) {\n  background-image: var(--gradient-button);\n  background-color: var(--primary-red-medium);\n  color: var(--text-on-gradient);\n  border: none;\n  box-shadow: var(--shadow-lg);\n}\ndiv.profile-actions > button.auth-button:not(.secondary):hover:not(:disabled) {\n  box-shadow: var(--shadow-button-hover);\n  transform: scale(1.03);\n}\n\n/* Style SECONDARY auth-button WITHIN profile-actions (Cancel) */\ndiv.profile-actions > button.auth-button.secondary {\n  background: transparent !important;\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n  box-shadow: none;\n}\ndiv.profile-actions > button.auth-button.secondary:hover:not(:disabled) {\n  background: var(--bg-secondary) !important;\n  border-color: var(--text-secondary);\n  box-shadow: var(--shadow-lg);\n  transform: scale(1.03);\n}\n\n/* Specific Style ONLY for Profile Logout Button */\ndiv.profile-actions > button.profile-logout-button {\n  background: var(--error-color); /* Red background */\n  color: white; /* White text */\n  border: none; /* No border */\n}\ndiv.profile-actions > button.profile-logout-button:hover:not(:disabled) {\n  background: var(--primary-red-dark); /* Darker red on hover */\n  box-shadow: var(--shadow-lg);\n  transform: scale(1.03);\n}\n\n/* Disabled state for ALL buttons inside profile-actions */\ndiv.profile-actions > button.auth-button:disabled,\ndiv.profile-actions > button.profile-logout-button:disabled {\n  background: var(--border-primary) !important; /* Use background property */\n  background-image: none !important; /* Remove gradient */\n  color: var(--text-secondary) !important;\n  border-color: var(--border-primary) !important;\n  cursor: not-allowed;\n  opacity: 0.8;\n  box-shadow: none;\n  transform: none;\n}\n\n\n/* Profile messages */\n.profile-form-container .error-message,\n.profile-form-container .success-message {\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.9rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .profile-form-container { padding: 1.5rem !important; }\n}\n@media (max-width: 500px) {\n  .profile-actions {\n    flex-direction: column-reverse; /* Stack buttons */\n    align-items: center; /* Center items horizontally */\n  }\n  /* Target ALL direct button children */\n  .profile-actions > button {\n    width: 100%; /* Ensure full width */\n    max-width: 300px; /* Limit max width on mobile */\n  }\n  .profile-page-header { padding: 0 0.5rem; }\n  .admin-header-button {\n      position: static; transform: none; margin-top: 1rem; display: block;\n      margin-left: auto; margin-right: auto; max-width: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
